import script from "./ImageAndButtonsModalTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageAndButtonsModalTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ImageAndButtonsModalTemplate.vue?vue&type=style&index=0&id=21464a4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21464a4e"]])

export default __exports__